export abstract class IUserLoginCustomerSelectDialogService {

  abstract userLoginCustomerSelectDialogShow(
    callbackClose: () => void,
  ): void;

}
